// extracted by mini-css-extract-plugin
export default {"root":"_3xA8iA9C0Sy6bxakIOAh0g=="};